
      import API from "!../../../../../native-listing-final-build/senaite.app.listing/webpack/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../native-listing-final-build/senaite.app.listing/webpack/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../../native-listing-final-build/senaite.app.listing/webpack/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../native-listing-final-build/senaite.app.listing/webpack/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../native-listing-final-build/senaite.app.listing/webpack/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../native-listing-final-build/senaite.app.listing/webpack/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../native-listing-final-build/senaite.app.listing/webpack/node_modules/css-loader/dist/cjs.js!./Loader.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../native-listing-final-build/senaite.app.listing/webpack/node_modules/css-loader/dist/cjs.js!./Loader.css";
       export default content && content.locals ? content.locals : undefined;
